import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'brightside-web-savings-initial-card',
    templateUrl: './savings-initial-card.component.html',
    styleUrls: ['./savings-initial-card.component.scss'],
    imports: [BrightsideUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SavingsInitialCardComponent {
  private _router: Router = inject(Router);

  savingsInitialCard: ActionCardConfigInterface = {
    label: 'FINANCIAL_TOOL_SAVINGS_LABEL',
    title: 'FINANCIAL_TOOL_SAVINGS_TITLE',
    image: '/assets/savings-piggy-bank.png',
    cardStyle: 'small',
    shadow: true,
    backgroundSize: 'cover',
    removeMaxWidth: true
  }

  routeToSavings() {
    this._router.navigate(['accounts', 'savings', 'dashboard']);
  }
}
